<template>
  <section class="row">
    <div class="col-9 mx-auto">
      <div class="h5">
        Territorialité
      </div>
      <div class="text-gray-600 my-3">
        Vous pouvez valider votre modification et passer à la signature des
        déclarations, ou bien poursuivre vos modifications.
      </div>
    </div>
    <section
      class="input-group d-flex flex-md-row flex-column
      justify-content-md-around justify-content-center"
    >
      <div
        v-for="situation in situations"
        :key="situation.code"
        class="form-check px-0 text-center mx-auto mb-4"
        style="max-width:279px"
      >
        <v-icon
          class="d-flex mx-auto mb-2 cursor-pointer"
          folder="common/svg"
          :icon="`${situation.icon}-${customModel === situation.code ? 'on' : 'off'}`"
          width="100"
          height="70"
          @click="setCustomModel(situation)"
        />
        <label class="form-check-label m-0">
          <input
            :id="situation.code"
            v-model="customModel"
            type="radio"
            class="form-check-input px-0 mx-0"
            :value="situation.code"
            :checked="`${customModel === situation.code ? 'true' : 'false'}`"
            @click="setCustomModel(situation)"
          >
        </label>
        <div class="d-flex flex-column">
          <div class="fw-bold my-1">
            {{ situation.label }}
          </div>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EditionTerritorialite',
  data() {
    return {
      customModel: null,
      situations: [
        {
          label: 'France',
          code: 'FRANCE',
          icon: 'france',
        },
        {
          label: 'Europe',
          code: 'EUROPE',
          icon: 'europe',
        },
        {
          label: 'Monde entier',
          code: 'MONDE',
          icon: 'world',
        }],
    };
  },
  computed: {
    ...mapGetters({
      contract: 'contract/get',
    }),
    isValid() {
      return this.customModel !== null;
    },
  },
  mounted() {
    this.validation(this.isValid);
    this.customModel = this.contract.risk.equipment.territorialite;
  },
  methods: {
    validation(value) {
      this.$emit('validation', value);
    },
    setCustomModel(situation) {
      this.$store.dispatch('contract/updateSubscription', {
        value: situation.code,
        path: 'risk.equipment.territorialite',
      });
      this.customModel = situation.code;
    },
  },
};
</script>
